import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const BenefitIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [benefitPageIndex, setBenefitPageIndex] = useState(1);
    const [benefitPageSize, setBenefitPageSize] = useState(store.main.pageSize);
    const [benefitIdList, setBenefitIdList] = useState([]);
    const [benefitTotal, setBenefitTotal] = useState(0);
    const [benefitList, setBenefitList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/benefit/index"});

            handleSearchBenefit();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadBenefit(benefitPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadBenefit(benefitPageIndex, benefitPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchBenefit = () => {
        handleLoadBenefit(1, benefitPageSize);
    };

    const handleLoadBenefit = (benefitPageIndex, benefitPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = benefitPageIndex;
        data.pageSize = benefitPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/benefit/business/website/v1/list",
            data: data,
            success: (response) => {
                setBenefitPageIndex(benefitPageIndex);
                setBenefitPageSize(benefitPageSize);
                setBenefitIdList([]);
                setBenefitTotal(response.data.total);
                setBenefitList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddBenefit = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/benefit/add",
        });
    };

    const handleEditBenefit = (benefitId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/benefit/edit/" + benefitId,
        });
    };

    const handleDelBenefit = () => {
        if (benefitIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/benefit/business/website/v1/delete",
                    data: {
                        benefitIdList: benefitIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setBenefitIdList([]);

                        handleLoadBenefit(benefitPageIndex, benefitPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeBenefitIdList = (benefitIdList) => {
        setBenefitIdList(benefitIdList);
    };

    const handleChangeBenefitPagination = (benefitPageIndex, benefitPageSize) => {
        handleLoadBenefit(benefitPageIndex, benefitPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddBenefit}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={benefitIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelBenefit}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchBenefit}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="权益名称"
                                labelAlign={"left"}
                                name="benefitName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入权益名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入权益名称" onPressEnter={handleSearchBenefit} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.benefitId}
                        columns={[
                            {
                                title: "权益名称",
                                dataIndex: "benefitName",
                            },
                            {
                                title: "企业名称",
                                dataIndex: "enterpriseName",
                            },
                            {
                                title: "开始日期",
                                dataIndex: "benefitStart",
                            },
                            {
                                title: "结束日期",
                                dataIndex: "benefitEnd",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditBenefit(record.benefitId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={benefitList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: benefitIdList,
                            onChange: handleChangeBenefitIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: benefitPageIndex,
                            pageSize: benefitPageSize,
                            total: benefitTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeBenefitPagination,
                            onShowSizeChange: handleChangeBenefitPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

BenefitIndex.propTypes = {};

BenefitIndex.defaultProps = {};

export default BenefitIndex;
